var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "17 17 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    fill: "#000",
    d: "M22.837 28.674a5.731 5.731 0 0 0 3.727-1.36l4.53 4.53a.518.518 0 0 0 .375.156.531.531 0 0 0 .375-.906l-4.53-4.53a5.827 5.827 0 0 0 1.36-3.727A5.838 5.838 0 0 0 22.837 17C19.627 17 17 19.627 17 22.837c0 3.223 2.627 5.837 5.837 5.837zm0-10.613a4.78 4.78 0 0 1 4.776 4.776 4.772 4.772 0 0 1-4.776 4.776 4.78 4.78 0 0 1-4.776-4.776 4.789 4.789 0 0 1 4.776-4.776z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3df861d03e48f753f95e43ce1acfaffd.svg";
export { ForwardRef as ReactComponent };